type FormSectionSubtitleProps = Readonly<{
  children: string
}>

const FormSectionSubtitle = ({ children }: FormSectionSubtitleProps) => (
  <p className="mt-1 text-sm leading-6 text-slate-600">{children}</p>
)

export { FormSectionSubtitle, type FormSectionSubtitleProps }
